import ActionButtons from './ActionButtons';
import { actionButtonsComiteeName } from './ActionButtons/actionButtonsArray';

/**
 * @description bu komponent  sorumlu heyete gonderilen maddelerin  kararlari icin link yonlendirmelerini saglar.
 * @param {number} step - step number
 * @param {string} committee - committee (owner_committee, eu_control, pub_control)
 * @param {number} offerId - offer id
 * @returns {React.ReactNode}
 */
function OwnComiteeControlDecisions({ committee, step, offerId }) {
  return (
    <ActionButtons
      buttonType={actionButtonsComiteeName.ownComiteeControlDecisions}
      committee={committee}
      step={step}
      offerId={offerId}
    />
  );
}
export default OwnComiteeControlDecisions;
